"use strict";
import { createAdaptiveRefetchContext } from "appGraphql/data/apollo/AdaptiveRefetch";
const {
  Provider: AdaptiveTokenBalancesProvider,
  useQuery: useTokenBalancesQuery,
  PrefetchWrapper: PrefetchBalancesWrapper
} = createAdaptiveRefetchContext();
export { AdaptiveTokenBalancesProvider, PrefetchBalancesWrapper, useTokenBalancesQuery };
